import {TimeType} from 'platform/components';
import {z} from 'zod';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

export const requestDetailFormSchema = z
  .object({
    isFixedPrice: z.boolean().nullish(),
    fixedPrice: z.number().nullish(),
    description: z.string().nullish(),
    solution: z.string().nullish(),
    competence: z.string().nullish(),
    estimatedTime: z.custom<TimeType>().nullish(),
    isPartsRequest: z.boolean().nullish(),
    vatType: z.string().nullish(),
  })
  .superRefine((data, ctx) => {
    if (data.isFixedPrice) {
      if (isNil(data.fixedPrice)) {
        ctx.addIssue({
          path: ['fixedPrice'],
          code: z.ZodIssueCode.custom,
          message: i18n.t('general.validations.fieldIsRequired'),
        });
      }
      if (isNilOrEmpty(data.vatType)) {
        ctx.addIssue({
          path: ['vatType'],
          code: z.ZodIssueCode.custom,
          message: i18n.t('general.validations.fieldIsRequired'),
        });
      }
    }
  });

export type RequestDetailFormType = z.infer<typeof requestDetailFormSchema>;
